import { PaymentElement } from '@stripe/react-stripe-js'
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js'

type StripePaymentElementsProps = {
  onChange?: (event: StripePaymentElementChangeEvent) => void
  wallets?: boolean
}

export const StripePaymentElements = ({
  onChange,
  wallets = true
}: StripePaymentElementsProps) => {
  const handleOnChange = (event: StripePaymentElementChangeEvent) => {
    if (onChange) onChange(event)
  }

  return (
    <div className='mt-4 mb-4'>
      <PaymentElement
        id='card-element'
        onChange={handleOnChange}
        options={{
          wallets: {
            applePay: wallets ? 'auto' : 'never',
            googlePay: wallets ? 'auto' : 'never'
          },
          terms: { card: 'never' } // Disclosure about card details being saved is handled in the forms
        }}
      />
    </div>
  )
}
